module.exports = __webpack_public_path__ + "img/operate1.b5e04b56.png";